import { WithLoadingProps } from '@adjust/dashboard-components';
import { connectWithStore } from '@common/connectWithStore';

import { UsersPage, UsersPageDispatchProps, UsersPageStateProps } from '@react/Pages/UsersPage/UsersPage/UsersPage';

import {
  fetchUsers,
  getFilteredList,
  getFilteredAdvancedList,
  selectSearchTerm,
  selectIsLoading,
  setSearchTerm,
} from '@redux/ducks/users';

const mapStateToProps = (state): UsersPageStateProps & WithLoadingProps => {
  const users = getFilteredList(state);
  const advancedUsers = getFilteredAdvancedList(state);
  const searchTerm = selectSearchTerm(state);
  const isLoading = selectIsLoading(state);

  return {
    users,
    advancedUsers,
    searchTerm,
    isLoading,
  };
};

const mapStateToDispatch: UsersPageDispatchProps = {
  fetchUsers,
  setSearchTerm,
};

export const UsersPageContainer = connectWithStore(mapStateToProps, mapStateToDispatch)(UsersPage);
